helpers = (function () {
  function getSymbolPos(reel, row) {
    const symbolReel = resourceManager.get("slotContainer:reelContainer:reel" + reel);
    const symPos = {
      x: symbolReel.x,
      y: symbolReel.y + row * gameData.symbolHeight,
    };
    const containerPos = resourceManager.get("slotContainer").position;
    const containerScaleX = resourceManager.get("slotContainer").scale.x;
    const containerScaleY = resourceManager.get("slotContainer").scale.y;

    let pos = {
      x: symPos.x * containerScaleX + containerPos.x,
      y: symPos.y * containerScaleY + containerPos.y,
    };
    return pos;
  }

  function getTrailPanelSymbolPos(index) {
    const trailPanel = resourceManager.get(
      "freeSpinsTrailPanel:freeSpinsTrailPanelContainer:freeSpinsTrailPanelScale:fishermenContainer:symbol" + index
    );
    const panelPos = {
      x: trailPanel.x,
      y: trailPanel.y,
    };
    const containerPos = resourceManager.get("freeSpinsTrailPanel:freeSpinsTrailPanelContainer").position;
    const containerScaleX = resourceManager.get("freeSpinsTrailPanel:freeSpinsTrailPanelContainer").scale.x;
    const containerScaleY = resourceManager.get("freeSpinsTrailPanel:freeSpinsTrailPanelContainer").scale.y;

    let pos = {
      x: panelPos.x * containerScaleX + containerPos.x,
      y: panelPos.y * containerScaleY + containerPos.y,
    };
    return pos;
  }

  return {
    getSymbolPos: getSymbolPos,

    getTrailPanelSymbolPos: getTrailPanelSymbolPos,
  };
})();
